import React from 'react';

import styles from './Embed.module.scss';

interface Props {
  height?: string;
  width?: string;
  src?: string;
  title?: string;
}

/* Show iframe if we have src, otherwise show placeholder */
const Embed: React.FC<Props> = (props) => {
  return (
    <div className={styles.embed}>
      {props.src ? (
        <iframe
          src={props.src}
          title={props.title}
          width={props.width ? props.width : '640'}
          height={props.height ? props.height : '480'}
        ></iframe>
      ) : (
        <div></div>
        // <div className={styles.placeholder}>
        //   <p>A recording will be added here after the workshop.</p>
        // </div>
      )}
    </div>
  );
};

Embed.displayName = 'Embed';

export default Embed;
